/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState, useRef } from "react";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
  //   ConversationHeader,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import { useMutation, useLazyQuery } from "@apollo/client";
import { SEND_MESSAGE } from "../Apollo/graphql/Mutation/ChatMutations/SendMessage";
import { SEND_TYPING } from "../Apollo/graphql/Mutation/ChatMutations/SendTyping";
import { GET_CHATS } from "../Apollo/graphql/Query/GetChat";
import { GENERATE_PRE_SIGNED_URL_MUTATION } from "../Apollo/graphql/Mutation/UploadFile";
import { uploadtoS3 } from "../Api/fileUpload";
import { useStoreState, useStoreActions } from "../myStore";
import {
  getUserId,
  whiteListFileTypes,
  isImage,
  isAllowedFile,
} from "../utils/utilsFunctions";
import { Spin, Tooltip } from "antd";
import { FileTextTwoTone } from "@ant-design/icons";
import moment from "moment";


interface MProps {
  currentChat?: any;
  isAdmin?: Boolean;
}

const MessageX: FC<MProps> = ({ currentChat, isAdmin }) => {
  const attachButton: any = useRef(null);
  const [onChangeFlag, setOnChangeFlag] = useState(false);
  const userId = getUserId();

  const [uploadFileMutation] = useMutation(GENERATE_PRE_SIGNED_URL_MUTATION);

  const channels = useStoreState((state: any) => {
    return isAdmin ? state.chat.allChannels : state.chat.channels;
  });
  const setChannels = useStoreActions((actions: any) => {
    return isAdmin ? actions.chat.setAllChannels : actions.chat.setChannels;
  });

  const [sendMessageMutation] = useMutation(SEND_MESSAGE);
  const [sendTypingMutation] = useMutation(SEND_TYPING);

  const [getChats, { loading }] = useLazyQuery(GET_CHATS, {
    onCompleted: (data: any) => {
      const channelsCopy = [...channels];
      const channelIndex = channelsCopy.findIndex(
        (c) => c._id === currentChat._id
      );
      channelsCopy[channelIndex] = {
        ...channelsCopy[channelIndex],
        messages: data.chats,
      };
      setChannels(channelsCopy);
    },
    fetchPolicy: "network-only",
  });
  useEffect(() => {
    if (currentChat && currentChat._id) {
      getChats({ variables: { channelId: currentChat?._id } });
    }
  }, [currentChat]);

  const selectedChannel =
    channels && channels?.find((c) => c._id === currentChat?._id);

  const handleSend = async (text: any, type: any = "text") => {
    sendTypingMutation({
      variables: {
        channelId: currentChat?._id,
        typing: false,
      },
    });
    setOnChangeFlag(false);
    if (text.trim().length > 0) {
      sendMessageMutation({
        variables: {
          input: {
            channelId: currentChat._id,
            message: text,
            type: type,
          },
        },
      })
        .then(() => true)
        .catch((error) => console.log(error));
    }
  };

  const renderMessageList = () => {
    const reversedMessage =
      (selectedChannel &&
        selectedChannel.messages &&
        [...selectedChannel.messages].reverse()) ||
      [];
    const pseudoUser = isAdmin && reversedMessage.length ? reversedMessage[0]["senderId"] : userId;
    return (
      <MessageList
        typingIndicator={
          selectedChannel &&
          selectedChannel.typing &&
          selectedChannel.typing.typing &&
          selectedChannel.typing.channel._id === currentChat?._id &&
          selectedChannel.typing.userName ? (
            <TypingIndicator
              content={`${selectedChannel.typing.userName} is typing`}
            />
          ) : null
        }
      >
        {reversedMessage.map((message) => {
          const isUserSender = message.senderId === pseudoUser;
          if (!message.message || message.message.length === 0) {
            return null;
          }
          let messageDate = moment(message.createdAt).format(
            "DD MMM YYYY h:mm a"
          );
          if (
            moment(message.createdAt).isBetween(
              moment().startOf("week"),
              moment().endOf("week")
            )
          ) {
            messageDate = moment(message.createdAt).format("dddd h:mm a");
          }
          if (
            moment(message.createdAt).isBetween(
              moment().startOf("day"),
              moment().endOf("day")
            )
          ) {
            messageDate = moment(message.createdAt).format("h:mm a");
          }
          if (message.type === "text") {
            return (
              <Tooltip
                key={message._id}
                placement={isUserSender ? "topRight" : "topLeft"}
                title={messageDate}
              >
                <Message
                  key={message._id}
                  model={{
                    message: message.message,
                    sentTime: message.createdAt,
                    sender: message.sender?.firstName || "",
                    direction: isUserSender ? "outgoing" : "incoming",
                    position: "single",
                  }}
                >
                </Message>
              </Tooltip>
            );
          } else if (message.type === "file") {
            return (
              <Tooltip
                key={message._id}
                placement={isUserSender ? "topRight" : "topLeft"}
                title={messageDate}
              >
                <Message
                  key={message._id}
                  type="image"
                  model={{
                    sentTime: message.createdAt,
                    sender: message.sender.firstName,
                    direction: isUserSender ? "outgoing" : "incoming",
                    position: "single",
                    payload: {
                      src: message.message,
                      alt: "messageimage",
                      width: "200px",
                    },
                  }}
                >
                  {!isImage(false, message.message) && (
                    <Message.CustomContent>
                      <a
                        href={message.message}
                        target="_blank"
                        rel="noreferrer"
                        style={{ color: "black" }}
                      >
                        <FileTextTwoTone style={{ fontSize: "42px" }} />
                        <span>{message.message.split("/").pop()}</span>
                      </a>
                    </Message.CustomContent>
                  )}
                </Message>
              </Tooltip>
            );
          }
          return null;
        })}
      </MessageList>
    );
  };

  return (
    <MainContainer>
      <ChatContainer>
        {/* {renderHeader()} */}
        <MessageList>
          {loading && <Spin />}
          {currentChat ? (
            renderMessageList()
          ) : (
            <div>Open conversation to start the chat</div>
          )}
          {/* <TypingIndicator /> */}
        </MessageList>
        {!isAdmin && (
          <MessageInput
            placeholder="Type message here"
            onAttachClick={(a) => {
              if (attachButton && attachButton.current) {
                attachButton.current.click();
              }
            }}
            onChange={(e: any) => {
              // setTexts(e);
              if (!onChangeFlag) {
                setOnChangeFlag(true);
                sendTypingMutation({
                  variables: {
                    typing: true,
                    channelId: selectedChannel._id,
                  },
                });
                setTimeout(() => {
                  sendTypingMutation({
                    variables: {
                      typing: false,
                      channelId: selectedChannel._id,
                    },
                  });
                  setOnChangeFlag(false);
                }, 5000);
              }
            }}
            onSend={(text) => handleSend(text)}
          />
        )}
      </ChatContainer>
      {!isAdmin && (
        <input
          ref={attachButton}
          accept={`image/*, ${whiteListFileTypes().join()}`}
          type="file"
          style={{ display: "none" }}
          onChange={async (event) => {
            if (
              event &&
              event.target &&
              event.target.files &&
              event.target.files
            ) {
              for (let i = 0; i < event.target.files.length || 0; i++) {
                const file = event.target.files[i];
                if (!isAllowedFile(file)) {
                  return;
                }
                try {
                  const {
                    data: {
                      generate3dPreSignedURL: { url },
                    },
                  } = await uploadFileMutation({
                    variables: {
                      input: {
                        type: "put",
                        fileId: `${
                          file.lastModified +
                          Math.floor(Math.random() * 100) +
                          1
                        }`,
                        mime: file.name.includes(".stl")
                          ? "model/stl"
                          : file.type,
                      },
                    },
                  });
                  if (url) {
                    const result = await uploadtoS3(url, file);
                    if (result) {
                      handleSend(url.split("?")[0], "file");
                    }
                  }
                } catch (err) {
                }
              }
            }
          }}
        />
      )}
    </MainContainer>
  );
};

export default MessageX;
